import i18n from '../../../../i18n';
import { ProspectObject } from '../../../../types/SMT';
import { Party } from '../types';

type PartyParam = ProspectObject | Partial<Party>;

/**
 * Returns the party name based on the fact if it is a CUSTOMER or a COMPANY by the party object.
 * @param party The party object where the name should be extracted from/
 * @returns Returns the name or localized "Unknown" if no name is available.
 */
export const getPartyName = (party: PartyParam): string => {
  if (party.type === 'COMPANY') {
    return party.name ?? (i18n.t('UNKNOWN') || 'Unknown');
  }
  if (party.type === 'CUSTOMER') {
    const { first_name, infix, last_name, initials } = party;

    // Clean up null/undefined values and avoid literal "null" strings
    const cleanFirstName =
      first_name && first_name !== 'null' ? first_name : '';
    const cleanInitials = initials && initials !== 'null' ? initials : '';
    const cleanInfix = infix && infix !== 'null' ? infix : '';
    const cleanLastName = last_name && last_name !== 'null' ? last_name : '';

    // Use first_name if available, otherwise fall back to initials
    const displayName = cleanFirstName || cleanInitials;

    // Check if infix is already part of the last name to avoid duplication
    const infixAlreadyInLastName =
      cleanInfix &&
      cleanLastName.toLowerCase().includes(cleanInfix.toLowerCase());

    const nameParts = infixAlreadyInLastName
      ? [displayName, cleanLastName]
      : [displayName, cleanInfix, cleanLastName];

    const fullName = nameParts.filter(Boolean).join(' ');

    // Return localized "Unknown" if no name parts are available
    return fullName || i18n.t('UNKNOWN') || 'Unknown';
  }
  return i18n.t('UNKNOWN') || 'Unknown';
};
